import { useEffect } from 'react';
import {
  UseFormClearErrors,
  UseFormSetError,
  UseFormWatch,
} from 'react-hook-form';

type Args = {
  watch: UseFormWatch<any>;
  setError: UseFormSetError<any>;
  clearErrors: UseFormClearErrors<any>;
  passwordField: string;
  confirmField: string;
};

export const usePasswordMatch = ({
  watch,
  setError,
  clearErrors,
  passwordField,
  confirmField,
}: Args) => {
  const pass = watch(passwordField);
  const confirmPass = watch(confirmField);

  const isPasswordsMismatch = !!pass && !!confirmPass && pass !== confirmPass;

  const isPasswordEmpty = !pass || !confirmPass;

  useEffect(() => {
    if (isPasswordsMismatch) {
      setError(passwordField, {
        type: 'mismatch',
        message: 'Passwords do not match',
      });

      setError(confirmField, {
        type: 'mismatch',
        message: 'Passwords do not match',
      });
    } else {
      clearErrors([passwordField, confirmField]);
    }
  }, [pass, confirmPass]);

  return {
    pass,
    confirmPass,
    isPasswordsMismatch,
    isPasswordEmpty,
  };
};
